import React from "react";
import { FaTelegramPlane } from "react-icons/fa";
import "./Navbar2.css";
import logoRoad from "./assets/images/logo.png";

export default function Navbar2() {
    return (
        <>
            {/* Первая навигация */}
            <nav className="nav-bar-top nav-bar-contact">
                <div className="nav-bar-top-right">
                    <p className="phone">📞 +9989433394443</p>
                    <a
                        href="https://t.me/your_telegram"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="telegram-link"
                        aria-label="Telegram"
                    >
                        <FaTelegramPlane />
                    </a>
                    <button className="btn-login">Личный кабинет</button>
                </div>
            </nav>

            {/* Вторая навигация */}
            <nav className="nav-bar-top nav-bar-main">
                <div className="nav-bar-top-left">
                    <a href="#" className="logo">
                        <img src="" alt="roadassist.uz" />
                    </a>
                    <ul className="links">
                        <li><a href="/ru">Главная</a></li>
                        <li><a href="/ru/about">О компании</a></li>
                        <li><a href="/ru/services">Услуги</a></li>
                        <li><a href="/ru/contact">Контакты</a></li>
                    </ul>
                </div>
            </nav>
        </>
    );
}
